import React, { useEffect, useRef, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../assets/DataView/DataViewDemo.css";
import "../../assets/DataView/index.css";
import "../../assets/css/AccordionDemo.css";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "jspdf-autotable";
import jsPDF from "jspdf";
import logoBig from "../../assets/logo1.png";
import { FilterMatchMode } from 'primereact/api';
import { getBanker, getLoanFile, getProduct, getStateWiseCities } from "../../services/userMasterUser";
import { errorMessage, successMessage } from "../../utils/alertMessage";
import { formatDate } from "../../constants/FormateDate";
import { bankerListUpload } from "../../services/bankListUpload";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";

export default function LoanFileList() {

  const navigate = useNavigate();
  const { state } = useLocation();

  const [products, setProducts] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(null);

  const ds = useRef(null);

  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(20);
  const [loadingMore, setLoadingMore] = useState(false);

  const [stateCitiesList, setStateCitiesList] = useState([])
  const [stateCityList, setStateCityList] = useState({});

  const [productDataValue, setProductDataValue] = useState("");
  const [stateValue, setStateValue] = useState('');
  const [cityValue, setCityValue] = useState('');

  const [productDataList, setProductDataList] = useState([])

  const citiesList = stateCityList[stateValue] || [];

  const [categoryValue, setCategoryValue] = useState("")
  const [branchCategoryValue, setBranchCategoryValue] = useState("")


  const bankCategoryList = [
    { label: "Nationalised Bank", value: "Nationalised bank" },
    { label: "Private Bank", value: "Private Bank" },
    { label: "Financial Institution", value: "Financial Institution" },
    { label: "Small Bank", value: "Small Bank" },
    { label: "Alternative Investment Fund", value: "Alternative Investment Fund" },
  ]

  const branchCategoryDataList = [
    { label: "Normal", value: "Normal" },
    { label: "Agri", value: "Agri" },
    { label: "MSME", value: "MSME" },
    { label: "Mid-Corporate", value: "Mid-Corporate" },
    { label: "Large-Corporate", value: "Large-Corporate" },
  ]


  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    bankerEmailId: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    nameOfBanker: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    mobile: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    designation: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    bankPolicy: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    address: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    productList: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    minimumLoanAmount: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    maximumLoanAmount: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    levelOfDepartmentSalesMinimum: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    levelOfDepartmentSalesMaximum: { value: null, matchMode: FilterMatchMode.STARTS_WITH },

  });

  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [searchByStatus, setSearchByStatus] = useState('nameOfBanker');

  const searchByStatusData = [
    { label: "Banker Email Id", value: "bankerEmailId" },
    { label: "Name Of Banker", value: "nameOfBanker" },
    { label: "Mobile", value: "mobile" },
    { label: "Designation", value: "designation" },
    { label: "Bank Policy", value: "bankPolicy" },
    { label: "Address", value: "address" },
    { label: "Status", value: "status" },
    { label: "Product List", value: "productList" },
    { label: "Minimum Loan Amount", value: "minimumLoanAmount" },
    { label: "Maximum Loan Amount", value: "maximumLoanAmount" },
    { label: "Level Of Department Sales Minimum", value: "levelOfDepartmentSalesMinimum" },
    { label: "Level Of Department Sales Maximum", value: "levelOfDepartmentSalesMaximum" },
  ];

  const typeData = {
    searchBy: "",
    searchText: "",
    limit: 100000,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    statusIn: [],
    leadIdIn: [state.id]
  };

  const fetchData = (data, append = false) => {
    setLoadingMore(true);

    getLoanFile(data)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs

          if (append) {
            setProducts((prev) => [...(prev || []), ...newData]);
          } else {
            setProducts(newData);
          }

          setTotalRecords(response.data.totalRecords || newData.length);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
        setLoadingMore(false);
      });
  };

  useEffect(() => {
    fetchData({
      ...typeData,
      limit: rows,
      offset: 0
    });

    const stateCitiesData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      cityIn: [],
      stateIn: []
    }

    getStateWiseCities(stateCitiesData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;

          // const stateList = Object.keys(Res).map((key) => ({
          //   key
          // }));

          const stateListArray = Object.keys(Res);

          const stateList = stateListArray.map((item) => ({
            label: item,
            value: item,
          }));

          setStateCitiesList(stateList)

          setStateCityList(Res)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })
      .finally(() => console.log(false));

    const typeProductData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: []
    };

    getProduct(typeProductData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          const productData = newData.map((item) => ({
            label: item.name,
            value: item.id,
          }));
          setProductDataList(productData);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })

  }, []);

  useEffect(() => {

    const hasValidFilter =
      stateValue ||
      cityValue ||
      categoryValue ||
      branchCategoryValue ||
      productDataValue;

    if (!hasValidFilter) return;

    const payload = {
      ...typeData,
      limit: rows,
      offset: 0,
      statusIn: [],
      categoryIn: categoryValue ? categoryValue : [],
      branchCategoryIn: branchCategoryValue ? branchCategoryValue : [],
      productIdIn: productDataValue ? productDataValue : [],
      addressInfo: { cityIn: cityValue ? cityValue : [], stateIn: stateValue ? [stateValue] : [] }
    };

    fetchData(payload);

  }, [
    stateValue,
    cityValue,
    categoryValue,
    branchCategoryValue,
    productDataValue,
  ]);

  const loadMore = () => {
    const newOffset = first + rows;

    fetchData(
      {
        ...typeData,
        limit: rows,
        offset: newOffset
      },
      true // append mode
    );

    setFirst(newOffset);
  };

  const onFilter = (event) => {
    setFilters(event.filters);

    let searchBy = "";
    let searchText = "";

    // Detect which column filter is applied
    Object.keys(event.filters).forEach((key) => {
      if (key !== "global" && event.filters[key]?.value) {
        searchBy = key;
        searchText = event.filters[key].value;
      }
    });

    fetchData({
      searchBy,
      searchText,
      limit: 20,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: []
    });
  };

  // const onGlobalFilterChange = (e) => {
  //   const value = e.target.value;

  //   const _filters = { ...filters };
  //   _filters.global.value = value;

  //   setFilters(_filters);
  //   setGlobalFilterValue(value);

  //   fetchData({
  //     searchBy: "",
  //     searchText: value,
  //     limit: 20,
  //     offset: 0,
  //     sortBy: "",
  //     sortOrder: "desc",
  //     statusIn: []
  //   });
  // };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;

    setGlobalFilterValue(value);
    setFirst(0);
    setProducts([]);

    fetchData({
      searchBy: searchByStatus,
      searchText: value,
      limit: 20,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: []
    });
  };


  const itemTemplate = (data) => {
    return (
      <div>
      </div>
    )
  }

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  <h5 className="card-title flex">
                    <div
                      className="mr-3 cursor-pointer"
                      onClick={() => navigate("/operation-lead/list")}
                    >
                      <i class="bi bi-arrow-left-circle-fill"></i>
                    </div> Loan File List
                  </h5>
                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignSelf: "center" }}>
                    <div style={{ alignSelf: "center" }}>
                      <Link
                        to="/create-loan-file"
                        state={{ leadId: state }}
                        className="move-btn move-btn-blue center-text"
                      >
                        Create
                      </Link>
                    </div>

                  </div>
                </div>
                {/* <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <div className="row">
                    <div className="col-md mb-2">
                      <InputText
                        type="text"
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Keyword Search"
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={searchByStatusData}
                        value={searchByStatus}
                        onChange={(e) => {
                          setSearchByStatus(e.value);
                        }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <MultiSelect
                        style={{ width: "100%" }}
                        value={productDataValue}
                        onChange={(e) => setProductDataValue(e.value)}
                        options={productDataList}
                        optionLabel="label"
                        placeholder="Select Product"
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        value={stateValue}
                        onChange={(e) => {
                          setStateValue(e.value);
                          setCityValue([])

                        }
                        }
                        options={stateCitiesList}
                        optionLabel="label"
                        placeholder="Select a State"
                        filter
                        filterDelay={400}
                      />
                    </div>

                    <div className="col-md mb-2">
                      <MultiSelect
                        style={{ width: "100%" }}
                        value={cityValue}
                        onChange={(e) => setCityValue(e.value)}
                        options={citiesList}
                        placeholder="Select City"
                      />
                    </div>
                    </div>
                    </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <div className="row">
                    <div className="col-md mb-2">
                      <MultiSelect
                        style={{ width: "100%" }}
                        options={bankCategoryList}
                        value={categoryValue}
                        onChange={(e) => 
                          setCategoryValue(e.value)}
                        optionLabel="label"
                        placeholder="Select Category"
                      />
                    </div>
                    <div className="col-md mb-2">
                      <MultiSelect
                        style={{ width: "100%" }}
                        options={branchCategoryDataList}
                        value={branchCategoryValue}
                        onChange={(e) =>
                          setBranchCategoryValue(e.value)}
                        optionLabel="label"
                        placeholder="Select Branch Category"
                      />
                    </div>

                  </div>

                  
                </div>*/}
                <div className="dataview-demo">
                  <div className="card">
                    <DataTable
                      value={products}
                      // lazy
                      dataKey="id"
                      paginator
                      paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                      rows={rows}
                      rowsPerPageOptions={[rows, rows + 50, rows + 100]}
                      loading={loadingMore}
                      className="p-datatable-customers client-table-design"
                      resizableColumns
                      columnResizeMode="fit"
                      filters={filters}
                      onFilter={onFilter}
                      // filterDisplay="row"
                      globalFilterFields={['id', 'createdDate', 'name', "mobile", "city", "state"]}
                      stripedRows
                    >
                      <Column
                        header="#"
                        resizeable={false}
                        className="product-category table-design"
                        body={(data, options) => options.rowIndex + 1}
                      ></Column>
                      {/*<Column
                        field="fileNo"
                        header="File No."
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.fileNo}
                          </span>
                        )}
                      ></Column>*/}
                      <Column
                        field="requestedDate"
                        header="Requested Date"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {formatDate(rowData?.createdDate)}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="requestAmount"
                        header="Request Amount"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.requestAmount}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="fileStatus"
                        header="File Status"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.fileStatus}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="sanctionAmount"
                        header="Sanction Amount"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.sanctionAmount}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="sanctionOn"
                        header="Sanction On"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.sanctionAmount > 0 ? formatDate(rowData.sanctionOn) : ""}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="disbursedAmount"
                        header="Disbursed Amount"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.disbursedAmount}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="disbursedOn"
                        header="Disbursed On"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.disbursedAmount > 0 ? formatDate(rowData?.disbursedOn) : ""}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="Edit"
                        header="Edit"
                        className="product-category table-design"
                        body={(rowData) => (
                          <Link
                            to={"/create-loan-file"}
                            state={
                              {
                                leadId: state,
                                loanFileEdit: rowData
                              }
                            }
                            className="move-btn move-btn-yellow center-text"
                          >
                            Edit <i className="bi bi-pencil-square"></i>
                          </Link>
                        )}
                      ></Column>
                    </DataTable>
                  </div>
                  <DataScroller
                    ref={ds}
                    value={products}
                    itemTemplate={itemTemplate}
                    rows={5}
                    loader
                  // footer={footer} 
                  // header="Click Load Button at Footer to Load More" 
                  />
                  {/*<div
                    className="flex justify-content-center fixed "
                    style={{ bottom: 30, left: 20 }}
                  >
                    <Button
                      type="text"
                      icon="pi pi-plus"
                      // label="More"
                      onClick={loadMore} // Update this to trigger `getData`
                    />
                  </div>*/}
                  {/*products && products.length < totalRecords && (
                    <div style={{ textAlign: "center", margin: "20px" }}>
                      <button
                        onClick={loadMore}
                        disabled={loadingMore}
                        style={{
                          padding: "10px 20px",
                          backgroundColor: "#1e439b",
                          color: "#fff",
                          border: "none",
                          cursor: "pointer",
                          borderRadius: "5px"
                        }}
                      >
                        {loadingMore ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
